module.exports = __webpack_public_path__ + "static/family-6b05a11147971e526b4939df54989ed5.jpg";